import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Tooltip component
 */
const Tooltip = ({ children, ...props }) => {
  const tooltipRef = useRef(null);
  const {
    open,
    className,
    content,
    ...otherProps
  } = props;
  const [isOpen, setIsOpen] = useState(open);
  const [position, setPosition] = useState({});
  const classNames = classnames(
    'tooltip d-inline-block',
    className,
  );
  useEffect(() => {
    function setTooltipPosition() {
      if (tooltipRef.current) {
        const bounding = tooltipRef.current.getBoundingClientRect();
        setPosition({
          x: bounding.x + bounding.width / 2,
          y: bounding.y + window.scrollY,
        });
      }
    }
    setTooltipPosition();
    window.addEventListener('resize', setTooltipPosition);
    return () => {
      window.removeEventListener('resize', setTooltipPosition);
    };
  }, []);
  return (
    <div
      ref={tooltipRef}
      className={classNames}
      onMouseEnter={() => { setIsOpen(true); }}
      onMouseLeave={() => { setIsOpen(false); }}
      {...otherProps}
    >
      {children}
      {
        ((open === undefined && isOpen) || open) && ReactDOM.createPortal(
          <div
            className="tooltip-content"
            style={{ left: position.x, top: position.y }}
          >
            {content}
          </div>,
          document.body,
        )
      }
    </div>
  );
};

Tooltip.propTypes = {
  /** Primary content. */
  children: PropTypes.any,
  /** Additional classes. */
  className: PropTypes.string,
  /** Tooltip content */
  content: PropTypes.element.isRequired,
  /** Opens tooltip */
  open: PropTypes.bool,
};

Tooltip.defaultProps = {
  children: '',
  className: '',
};

export { Tooltip };
